import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_URL } from '@core/services/api.tokens';
import { MemberOrganisation } from '@shared/models/organisation.interface';
import { OrganisationTreeItem } from '@shared/components/organisation-tree/organisation-tree.model';
import { Observable } from 'rxjs';

/** Shell / core HTTP for organisations — keeps `core` free of feature-settings imports. */
@Injectable({ providedIn: 'root' })
export class OrganisationsApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  /** The whole tenant hierarchy, flat. */
  findTree(): Observable<OrganisationTreeItem[]> {
    return this.http.get<OrganisationTreeItem[]>(`${this.apiUrl}/organisations/tree`, {
      withCredentials: true,
    });
  }

  findMine(): Observable<MemberOrganisation[]> {
    return this.http.get<MemberOrganisation[]>(`${this.apiUrl}/organisations/mine`, {
      withCredentials: true,
    });
  }
}
